import { addDays as addDaysFn, differenceInCalendarDays, format, parseISO } from 'date-fns';
import { sl } from 'date-fns/locale';
import { TimerState } from '../types/activity';

export function timerElapsedMs(timer: TimerState, now: number): number {
  if (timer.status === 'review') return timer.finalMs ?? timer.accumulatedMs;
  return timer.accumulatedMs + (timer.segmentStart !== null ? Math.max(0, now - timer.segmentStart) : 0);
}

export function formatClock(ms: number): string {
  const total = Math.floor(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const mm = String(m).padStart(2, '0');
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function formatDayLabel(iso: string): string {
  return format(parseISO(iso), 'EEEE, d. MMMM', { locale: sl });
}

export function formatShortDay(iso: string): string {
  return format(parseISO(iso), 'EEE d. M.', { locale: sl });
}

export function formatDate(iso: string): string {
  return format(parseISO(iso), 'd. M.', { locale: sl });
}

export function formatTimeOfDay(ts: number): string {
  return format(new Date(ts), 'HH.mm');
}

export function addDays(iso: string, n: number): string {
  return format(addDaysFn(parseISO(iso), n), 'yyyy-MM-dd');
}

/** 0 = ponedeljek … 6 = nedelja */
export function dayOfWeek(iso: string): number {
  return (parseISO(iso).getDay() + 6) % 7;
}

export function daysUntil(from: string, to: string): number {
  return differenceInCalendarDays(parseISO(to), parseISO(from));
}

export function overlapDays(aFrom: string, aTo: string, bFrom: string, bTo: string): number {
  const from = aFrom > bFrom ? aFrom : bFrom;
  const to = aTo < bTo ? aTo : bTo;
  if (from > to) return 0;
  return differenceInCalendarDays(parseISO(to), parseISO(from)) + 1;
}
